import resolveDependencies from './resolveDependencies';

lbRoutes.$inject = ['$stateProvider', '$urlRouterProvider'];
export default function lbRoutes($stateProvider, $urlRouterProvider) {
  $urlRouterProvider.otherwise(() => '/');

  $stateProvider
    .state('landing', {
      abstract: true,
      template: '<ui-view></ui-view>',
      data: {
        isPublic: true,
      },
    })

    .state('landing.login', {
      url: '/login',
      template: '<lb-login></lb-login>',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) =>
          require.ensure([], (require) => resolve(require('../components/lbLogin').name))
        ),
      },
      onEnter() {
        sessionStorage.clear();
      },
      data: {
        pageTitle: 'Lightning Book - Login',
        bodyClass: 'bg-login',
      },
    })
    .state('landing.lightningdisabled', {
      url: '/lightningdisabled',
      template: '<lb-lightning-disabled></lb-lightning-disabled>',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) =>
          require.ensure([], (require) => resolve(require('../components/lbLightningDisabled').name))
        ),
      },
      onEnter() {
        sessionStorage.clear();
      },
      data: {
        pageTitle: 'Lightning Book - Login disabled',
        bodyClass: 'lbdisabledColorBg',
      },
    })

    .state('app', {
      abstract: true,
      template: '<ui-view/>',
      resolve: {
        settings: [
          '$q',
          '$window',
          'settingsService',
          '$fancyModal',
          ($q, $window, settingsService, $fancyModal) =>
            $q.when(
              settingsService
                .get()
                .then((response) => {
                  return response;
                })
                .catch((error) => {
                  return error;
                })
            ),
        ],
      },
    })

    .state('app.error', {
      url: '/error',
      template: '<lb-error-screen></lb-error-screen>',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) =>
          require.ensure([], (require) => resolve(require('../components/lbErrorScreen').name))
        ),
      },
      data: {
        pageTitle: 'Page not found',
        bodyClass: 'bg-error',
      },
      params: {
        prev: null,
      },
    })
    .state('app.home', {
      url: '/',
      template: '<lb-home></lb-home>',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) =>
          require.ensure([], (require) => resolve(require('../components/lbHome').name))
        ),
      },
      data: {
        pageTitle: 'Lightning Book',
        bodyClass: 'bg-search',
      },
    })
    .state('app.mybookings', {
      url: '/my-bookings',
      template: '<lb-my-bookings></lb-my-bookings>',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) =>
          require.ensure([], (require) => resolve(require('../components/myBookings/lbMyBookings/lbMyBookings').name))
        ),
      },
      data: {
        pageTitle: 'My Bookings',
        bodyClass: 'bg-myBookings',
      },
    });
}



// WEBPACK FOOTER //
// ./src/routes/routes.lb.js